var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCircleNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 25.44 25.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information-circle",
    d: "M68.72,56A12.72,12.72,0,1,0,81.44,68.72,12.734,12.734,0,0,0,68.72,56Zm0,5.215a1.654,1.654,0,1,1-1.654,1.654A1.654,1.654,0,0,1,68.72,61.215Zm3.053,14.374h-5.6a1.018,1.018,0,1,1,0-2.035h1.781v-5.6H66.939a1.018,1.018,0,1,1,0-2.035h2.035a1.018,1.018,0,0,1,1.018,1.018v6.614h1.781a1.018,1.018,0,1,1,0,2.035Z",
    transform: "translate(-56 -56)",
    fill: "#a9a9a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleNewIcon);
export default __webpack_public_path__ + "static/media/information-circle-new-icon.fd1fd33c8affc826824dd7a743e7adb6.svg";
export { ForwardRef as ReactComponent };